import Cycle from "modules/cycles/components/Cycle";
import Container from "modules/Core/sub-modules/ui-kit/components/Container";
import withFocusedBoothId from "modules/booths/higher-order-components/withFocusedBoothId";
import styles from "./styles.module.scss";

const BoothActiveCycleTab = () => (
    <Container flex column alignCenter maxWidth className={styles.container} relative>
        <Cycle />
    </Container>
)

export default withFocusedBoothId(BoothActiveCycleTab);
